module.exports = __webpack_public_path__ + "static/media/valor1_1_1.cd4656ce.png";